import React from 'react';
import { useTranslations } from 'next-intl';
import { SectionWidth } from './atoms';
import { AgeCategoryRow } from './AgeCategoryRow';
import type { AgeCategoryGroup } from './types';
import styles from './LeaderboardAgeSection.module.css';

type LeaderboardAgeSectionProps = {
  groups: AgeCategoryGroup[];
};

export const LeaderboardAgeSection: React.FC<LeaderboardAgeSectionProps> = ({
  groups,
}) => {
  const t = useTranslations('performance-lab');

  if (groups.length === 0) return null;

  return (
    <SectionWidth
      className={styles.section}
      aria-label={t('leaderboard.age.listAria')}
    >
      <h2 className={styles.sectionTitle}>
        {t('leaderboard.age.sectionTitle')}
      </h2>
      {groups.map((group) => (
        <section
          key={group.label}
          className={styles.group}
          aria-label={t('leaderboard.age.groupAria', {
            label: group.label,
          })}
        >
          <h3 className={styles.groupLabel}>{group.label}</h3>
          <ol className={styles.rowList}>
            {group.entries.map((entry, index) => (
              <AgeCategoryRow
                key={`${group.label}-${entry.name ?? 'empty'}-${index}`}
                entry={entry}
              />
            ))}
          </ol>
        </section>
      ))}
    </SectionWidth>
  );
};
